import React, { Component, Fragment } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import API from '../../../utils/API';
import Form from './form';
import CreateFormModal from './modals/createForm';
import DeleteFormModal from './modals/deleteFormModal';
import LoadingWizard from '../../../components/spinner/wizard';
import SectionHeader from '../../../components/views/SectionHeader';
import FormGrid from '../../../components/tables/FormGrid';
import TabsContainer from '../../../components/views/TabsContainer';
import FormsTemplateCenter from './modals/FormsTemplateCenter';
import ActionButtonContainer from '../../../components/views/ActionButtonContainer';
import ViewsTable from '../../../components/tables/ViewsTable';
import RenameFormModal from './modals/renameFormModal';
import DuplicateFormModal from './modals/duplicateFormModal'
const ENV =
	process.env.NODE_ENV === 'production'
		? window.location.href.includes('planner.simple.events') ? `https://admin-api.simple.events/` : `https://beta-api.simple.events/`
		: `http://${window.location.hostname}:5015/`;
let batchCallback;
class EventForms extends Component {
	constructor(props) {
		super(props);
		const customFieldColumns = {
			name: 'Name',
			type: 'Type',
			submissions: 'Submissions',
			enableSubmissionReview: 'Confirmation Required',
			confirmationEmail: 'Confirmation Email',
			pageCount: 'Page Count',
			createdAt: 'Created At',
			updatedAt: 'Updated At',
			lastEditedBy: 'Last Edited By',
		};

		const defaultFieldTypes = {
			name: 'text',
			type: 'text',
			description: 'text',
			status: 'text',
			submissions: 'number',
			enableSubmissionReview: 'boolean',
			confirmationEmail: 'text',
			pageCount: 'number',
			createdAt: 'date',
			updatedAt: 'date',
			lastEditedBy: 'text',
		};
		const fieldCategories = {
			basics: {
				title: 'Basics',
				columns: [
					'name',
					'type',
					'description',
					'status',
					'submissions',
					'enableSubmissionReview',
					'confirmationEmail',
					'pageCount',
					'createdAt',
					'updatedAt',
					'lastEditedBy',
				]
			},
		};
		const toggledColumns = {};
		const normalizedColumns = Object.keys(customFieldColumns).map((cfc) => {
			toggledColumns[cfc] = true;
			return {
				label: customFieldColumns[cfc],
				key: cfc,
				value: cfc,
				type: (defaultFieldTypes && defaultFieldTypes[cfc]) || typeof defaultFieldTypes[cfc],
				sortAsc: false,
				sortDesc: false
			};
		});


		delete toggledColumns[Object.keys(defaultFieldTypes)[0]];


		this.state = {
			categoryColumns: fieldCategories,
			loading: true,
			checkedForms: [],
			addFormModalOpen: false,
			columns: customFieldColumns,
			columnTypes: defaultFieldTypes,
			normalizedColumns: normalizedColumns,
			toggledColumns: toggledColumns,
			deletedForms: [],
			formsViews: [],
			forms: [],
			availableEmails: [],
			deleteFormsModalOpen: false,
			isDeleting: false,
			toggleAddForm: false,
			templates: [],
			templatesHidden: true,
			hoverOn: null,
			toggleFormTemplateCenter: false,
			isGridLayout: false,
			selectedSection: 0,
			searchText: '',
			selectedRow: '',
			toggleRenameFormModal: false,
			toggleDuplicateFormModal: false,
			deleteSingleFormsModalOpen: false,

		};
	}

	async componentDidMount() {
		const { orgId, eventId, event } = this.props;

		await API().get(`Organizations/${orgId}/events/${eventId}/templates`).then((res) => {
			if (res.data) {
				const metadataOptions = [];
				{
					Object.keys(res.data.keyedData).forEach((key) => {
						const layer1 = res.data.keyedData[key];
						if (typeof layer1 === 'object') {
							Object.keys(layer1).forEach((key2) => {
								const layer2 = layer1[key2];
								if (typeof layer2 === 'object') {
									Object.keys(layer2).forEach((key3) => {
										if (
											key !== '_defaultLabel' &&
											key2 !== '_defaultLabel' &&
											key3 !== '_defaultLabel'
										) {
											metadataOptions.push(`${key}.${key2}.${key3}`);
										}
									});
								} else {
									if (key !== '_defaultLabel' && key2 !== '_defaultLabel') {
										metadataOptions.push(`${key}.${key2}`);
									}
								}
							});
						} else {
							if (key !== '_defaultLabel') {
								metadataOptions.push(`${key}`);
							}
						}
					});
				}
				this.setState({
					keyedMetadata: metadataOptions,
					keyedData: res.data.keyedData,
					availableEmails: [
						{ label: 'No Email', value: '' },
						...res.data.templates.map((e) => {
							return {
								value: e._id,
								label: e.name
							};
						})
					],

				});
			}
		});


		API().get(`Organizations/${orgId}/events/${eventId}/forms`).then((res) => {
			if (res.data) {
				this.setState({
					forms: res.data.forms.map((f) => {
						if (f.confirmationEmail && f.confirmationEmail !== '') {
							let email = this.state.availableEmails.find(e => {
								let campaignId = e.value;
								let formConfirmationEmail = f.confirmationEmail;
								if (campaignId === formConfirmationEmail) {
									return e;
								}
							});

							if (email) {
								f.confirmationEmail = email.label;

							} else {

								f.confirmationEmail = 'N/A';
							}


						} else {
							f.confirmationEmail = 'N/A';

						}
						f.link = `/${orgId}/events/${eventId}/forms/${f._id}`;
						return f;
					}),
					formsViews: res.data.formsViews,
					loading: false,
					formTemplates: res.data.formTemplates,

				});
			}
		});
	}



	deleteCheckedForms = async (forms) => {
		this.setState({ isDeleting: true });
		const { eventId, orgId } = this.props;
		await API()
			.post(`Organizations/${orgId}/events/${eventId}/forms/`, {
				forms: Object.keys(this.state.checkedForms),
				isDeleting: false
			})
			.then((res) => {
				if (res.data) {
					const filteredForms = this.state.forms.filter((f) => !this.state.checkedForms[f._id]);
					this.setState({
						forms: filteredForms
					}, () => {
						batchCallback && batchCallback('delete');
						this.props.refreshSectionCounts();
						this.toggleDeleteForms();
					});

				}
			});

		this.setState({
			checkedForms: {}
		});
	};
	deleteSingleForm = async (formId, callback) => {
		const { eventId, orgId } = this.props;
		await API()
			.post(`Organizations/${orgId}/events/${eventId}/forms/`, {
				forms: [formId],
				isDeleting: false
			})
			.then((res) => {
				if (res.data) {
					const filteredForms = this.state.forms.filter((f) => f._id !== formId);
					this.setState({
						forms: filteredForms
					}, () => {
						this.props.refreshSectionCounts();
						callback && callback();

					});

				}
			});

		this.setState({
			checkedForms: {}
		});
	};

	toggleDeleteForms = () => {
		this.setState({ deleteFormsModalOpen: !this.state.deleteFormsModalOpen, });
	};
	toggleAddForm = () => {

		const { toggleAddForm } = this.state;
		this.setState({ toggleAddForm: !toggleAddForm })

	}

	hidetemplates = () => {
		this.setState({ templatesHidden: !this.state.templatesHidden });
	};

	addForm = (form, callback) => {
		const { eventId, orgId } = this.props;
		const { forms } = this.state;
		let fixedForm = form;
		fixedForm.link = `/${orgId}/events/${eventId}/forms/${form._id}`;
		fixedForm.submissions = fixedForm.submissions.length;
		if (!fixedForm.confirmationEmail) {
			fixedForm.confirmationEmail = 'N/A';
		} else {

			let email = this.state.availableEmails.find(e => {
				let campaignId = e.value;
				let formConfirmationEmail = fixedForm.confirmationEmail;
				if (campaignId === formConfirmationEmail) {
					return e;
				}
			});

			if (email) {
				fixedForm.confirmationEmail = email.label;

			} else {

				fixedForm.confirmationEmail = 'N/A';
			}
		}


		this.setState({ forms: [...forms, fixedForm] }, () => {

			this.props.refreshSectionCounts();
			callback && callback();
		})


	}
	updateFormName = (formName) => {
		const form = this.state.forms.find((f) => f._id === this.state.selectedRow);
		if (form) {
			form.name = formName;
		}
		this.setState({
			forms: [...this.state.forms]
		}, () => {
			this.toggleRenameFormModal();
		});
	};



	updateForm = (form) => {
		const { eventId, orgId } = this.props;
		const { forms } = this.state;
		let fixedForm = JSON.parse(JSON.stringify(form));
		fixedForm.link = `/${orgId}/events/${eventId}/forms/${form._id}`;
		fixedForm.submissions = fixedForm.submissions.length;
		fixedForm.pageCount = fixedForm.pages.length;
		if (!fixedForm.confirmationEmail) {
			fixedForm.confirmationEmail = 'N/A';
		} else {
			let email = this.state.availableEmails.find(e => {
				let campaignId = e.value;
				let formConfirmationEmail = fixedForm.confirmationEmail;
				if (campaignId === formConfirmationEmail) {
					return e;
				}
			});

			if (email) {
				fixedForm.confirmationEmail = email.label;

			} else {

				fixedForm.confirmationEmail = 'N/A';
			}

		}


		let updatedForms = forms.map(f => {
			if (f._id === form._id) {
				return fixedForm;
			} else {
				return f;
			}
		})
		this.setState({ forms: updatedForms }, () => {

			this.props.refreshSectionCounts();
		})
	}

	toggleFormTemplateCenter = () => {
		this.setState({ toggleFormTemplateCenter: !this.state.toggleFormTemplateCenter });
	}
	toggleLayout = (selected) => {
		this.setState({ isGridLayout: selected });
	};

	updateSelected = (selectedIndex) => {
		this.setState({ selectedSection: selectedIndex, checkedForms: {} });
	};
	searchEntries = (searchText) => {
		this.setState({
			searching: searchText != '' ? true : false,
			searchText: searchText ? searchText : '',
		});
	};
	sortData = (column, sortAsc, sortDesc) => {
		const { normalizedColumns } = this.state;
		let nc = normalizedColumns;
		nc = nc.map((col) => {
			if (col.key == column.key) {
				col.sortAsc = sortAsc;
				col.sortDesc = sortDesc;
			} else {
				col.sortAsc = false;
				col.sortDesc = false;
			}
			return col;
		});

		this.setState({
			normalizedColumns: nc,
			selectedColumnSort: column,
			sortDesc: sortDesc == false ? true : false
		});
	};
	checkEntry = (entryId) => {
		const checked = this.state.checkedForms;
		checked[entryId] ? delete checked[entryId] : (checked[entryId] = true);
		this.setState({
			checkedForms: checked
		});
	};

	checkAllEntries = (entryIds) => {
		let checked = this.state.checkedForms;
		entryIds.length > 0
			? entryIds.forEach((entryId) => {
				checked[entryId] = true;
			})
			: (checked = {});

		this.setState({
			checkedForms: checked
		});
	};

	uncheckEntries = () => {
		this.setState({
			checkedForms: {}
		});

	}
	updatedCheckedForms = (checked) => {
		this.setState({ checkedForms: checked });
	};
	toggleRenameFormModal = (formId) => {
		const { toggleRenameFormModal } = this.state;
		this.setState({ toggleRenameFormModal: !toggleRenameFormModal, selectedRow: formId });
	};
	toggleDuplicateFormModal = (formId) => {
		const { toggleDuplicateFormModal } = this.state;
		this.setState({ toggleDuplicateFormModal: !toggleDuplicateFormModal, selectedRow: formId });
	}
	toggleDeleteForm = (formId) => {
		const { deleteSingleFormsModalOpen } = this.state;
		this.setState({ deleteSingleFormsModalOpen: !deleteSingleFormsModalOpen, selectedRow: formId });
	};



	render() {
		const { event, orgId, eventId, readOnly } = this.props;
		const { forms,
			loading,
			columns,
			isDeleting,
			deleteFormsModalOpen,
			toggleAddForm,
			keyedMetadata,
			keyedData,
			toggleFormTemplateCenter,
			selectedSection,
			searchText,
			selectedColumnSort,
			sortDesc,
			isGridLayout,
			toggledColumns,
			normalizedColumns,
			toggleRenameFormModal,
			toggleDuplicateFormModal,
			deleteSingleFormsModalOpen,
		} = this.state;
		let mainAction = [{ label: 'Add Form', onClick: this.toggleFormTemplateCenter }];
		let batchActions = [
			{
				label: 'Delete',
				iconClass: 'las la-trash-alt',
				class: 'danger',
				onClick: this.toggleDeleteForms
			}
		];
		let searchEnabled = true;
		let checkedEntryCount = Object.keys(this.state.checkedForms).length;
		let data = this.state.forms;
		let checkedRows = this.state.checkedForms;
		if (searchText.length > 0) {
			const searchTerms = searchText.toLowerCase().split(' ');
			searchTerms.forEach((term) => {
				if (term != '') {
					data = data.filter((entry) => {
						let found = false;
						Object.keys(columns).forEach((key) => {
							if (term != '' && entry[key] && entry[key].toString().toLowerCase().includes(term)) {
								found = true;
							}
						});
						return found;
					});
				}
			});
		}

		switch (selectedSection) {

			case 1:
				data = data.filter((p) => p.type === 'registration');
				break;
			case 2:
				data = data.filter((p) => p.type === 'general');
				break;
			case 3:
				data = data.filter((p) => p.type === 'custom');
				break;
			default:
				break;
		}
		let entriesLength = data.length;

		if (selectedColumnSort) {
			data = data.sort((a, b) => {
				const columnType = selectedColumnSort.type || typeof a[selectedColumnSort.key];
				if (a[selectedColumnSort.key] && b[selectedColumnSort.key]) {
					switch (columnType) {
						case 'string':
							return a[selectedColumnSort.key]
								.toLowerCase()
								.trim()
								.localeCompare(b[selectedColumnSort.key].toLowerCase().trim());
						case 'number':
							return a[selectedColumnSort.key] - b[selectedColumnSort.key];
						case 'date':
							return (
								new Date(a[selectedColumnSort.key]).getTime() -
								new Date(b[selectedColumnSort.key]).getTime()
							);
						case 'time':
							return (
								new Date(a[selectedColumnSort.key]).getTime() -
								new Date(b[selectedColumnSort.key]).getTime()
							);
						case 'boolean':
							const a1 = a[selectedColumnSort.key] ? 'yes' : 'no';
							const b1 = b[selectedColumnSort.key] ? 'yes' : 'no';
							return a1.localeCompare(b1);
						default:
							return a[selectedColumnSort.key]
								.toLowerCase()
								.trim()
								.localeCompare(b[selectedColumnSort.key].toLowerCase().trim());
					}
				} else if (a[selectedColumnSort.key]) {
					return 1;
				}
				return -1;
			});

			data = sortDesc ? data.reverse() : data;
		}
		const form = data.find((f) => f._id === this.state.selectedRow)
		return <Fragment>
			{!loading && (
				<Switch>

					<Route path={`/:organization/events/:eventId/forms/:formId`}>
						<Fragment>

							{!loading && (<Form
								event={this.props.event}
								account={this.props.account}
								eventId={eventId}
								readOnly={readOnly}
								orgId={this.props.orgId}
								keyedMetadata={keyedMetadata}
								keyedData={keyedData}
								forms={forms}
								fields={this.props.fields}
								addNewField={this.props.addNewField}
								availableEmails={this.state.availableEmails}
								groups={this.props.groups.map(g => {
									return { value: g._id, label: g.name, }
								})}
								updateForm={this.updateForm}
								updatePathOptions={this.props.updatePathOptions}
								deleteSingleForm={this.deleteSingleForm}
							/>)}
							<LoadingWizard text={'Loading Form'} loading={loading} />
						</Fragment>
					</Route>
					<Route path={`/:organization/events/:eventId/forms`}>

						<Fragment>

							<SectionHeader
								title={'Forms'}
								description="Create and manage registration and check-in forms. Add forms to pages to create a custom registration website."
								breadcrumbs={[
									{
										name: `${event.name}`,
									}
								]}
								style={{ paddingBottom: 0 }}
								enableLastLink={true}
							>
							</SectionHeader>
							<TabsContainer
								tabs={[{ title: 'All Forms' }, { title: 'Registration Forms' }, { title: 'General Forms' }, { title: 'Custom Forms' }]}
								updateSelected={this.updateSelected}
								selectedIndex={selectedSection}
							/>

							<div className="sectionContainer sectionBody">
								<ActionButtonContainer
									mainActions={mainAction}
									searchEnabled={searchEnabled}
									searchEntries={this.searchEntries}
									enabledViewSelection={true}
									isGridLayout={isGridLayout}
									toggleLayout={this.toggleLayout}
								/>

								{
									!isGridLayout ? (
										<div className='flex h-100 hasHeader'>
											<ViewsTable
												title={"Form"}
												columns={normalizedColumns}
												toggledColumns={toggledColumns}
												data={data}
												mainColumnActive={true}
												checked={checkedRows}
												checkRow={this.checkEntry}
												checkAllRows={this.checkAllEntries}
												sortData={this.sortData}
												defaultSort={'name'}
												sortDirection={'desc'}
												rowSettings={[
													{
														label: <span><i className='las la-pen mr-10'></i>Rename Form</span>,
														onClick: this.toggleRenameFormModal
													},
													{
														label: <span><i className='las la-copy mr-10'></i>Duplicate Form</span>,
														onClick: this.toggleDuplicateFormModal
													},
													{
														label: <span><i className='las la-trash mr-10'></i>Delete Form</span>,
														onClick: this.toggleDeleteForm
													}
												]}
											/>
										</div>
									) : (
										<FormGrid
											title={"Form"}
											orgId={orgId}
											eventId={eventId}
											data={data}
											checked={this.state.checkedForms}
											account={this.props.account}
											checkRow={(entryId) => {
												const checked = this.state.checkedForms;
												checked[entryId] ? delete checked[entryId] : (checked[entryId] = true);
												this.setState({
													checkedForms: checked
												});
											}} />)
								}

							</div>

							<ActionButtonContainer
								batchActions={batchActions}
								checkedEntryCount={checkedEntryCount}
								entriesLength={entriesLength}
								uncheckEntries={this.uncheckEntries}
							/>
							{toggleFormTemplateCenter && (
								<FormsTemplateCenter
									isOpen={toggleFormTemplateCenter}
									orgId={orgId}
									templates={[]}//localTemplates
									platformTemplates={this.state.formTemplates}
									event={event}
									keyedMetadata={keyedMetadata}
									toggle={this.toggleFormTemplateCenter}
									addForm={this.addForm}
									account={this.props.account}
									eventId={eventId}
									availableEmails={this.state.availableEmails}
								/>
							)}
							{toggleAddForm &&
								<CreateFormModal
									event={this.props.event}
									eventId={eventId}
									readOnly={readOnly}
									orgId={this.props.orgId}
									refreshSectionCounts={this.props.refreshSectionCounts}
									toggle={this.toggleAddForm}
								/>
							}
							{deleteFormsModalOpen && (
								<DeleteFormModal
									isOpen={deleteFormsModalOpen}
									delete={this.deleteCheckedForms}
									isDeleting={isDeleting}
									toggle={this.toggleDeleteForms}
									count={Object.keys(this.state.checkedForms).length}
									isMultiple={true}
								/>
							)}
							{toggleAddForm &&
								<CreateFormModal
									isOpen={toggleAddForm}
									event={this.props.event}
									availableEmails={this.state.availableEmails}
									eventId={eventId}
									readOnly={readOnly}
									orgId={this.props.orgId}
									addForm={this.addForm}
									toggle={this.toggleAddForm}
								/>
							}
							{toggleRenameFormModal && <RenameFormModal
								toggle={this.toggleRenameFormModal}
								isOpen={toggleRenameFormModal}
								name={form.name}
								formId={form._id}
								form={data.find((f) => f._id === this.state.selectedRow)}
								eventId={event._id}
								orgId={orgId}
								update={this.updateFormName}
							/>}
							{toggleDuplicateFormModal && <DuplicateFormModal
								toggle={this.toggleDuplicateFormModal}
								isOpen={toggleDuplicateFormModal}
								name={form.name}
								formId={form._id}
								eventId={event._id}
								orgId={orgId}

							/>}
							{deleteSingleFormsModalOpen && (
								<DeleteFormModal
									isOpen={deleteSingleFormsModalOpen}
									toggle={this.toggleDeleteForm}
									form={form}
									count={1}
									removeForm={this.deleteSingleForm}
									hasEllipsis={true}
								/>
							)}
						</Fragment>

					</Route>

				</Switch>
			)}
			<LoadingWizard text="Loading Forms" loading={loading} />

		</Fragment>;
	}
}

export default withRouter(EventForms);
